// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Jz2l","alert":"SettungsInbox_alert__9H8wV"};